import ApiService from "../api.services";

const DashboardService = {
  list: async function (type, name) {
    try {
      const response = await ApiService.get(`/api/dashboard/month?type=${type}&name=${name}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  total: async function (month) {
    try {
      const response = await ApiService.get(`/api/dashboard/total?month=${month}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default DashboardService;

export { DashboardService };

